import { AchievementsServiceProvider } from '../../../achievement/services/achievements-service/achievements-service';
import { App } from 'ionic-angular';
import { CampaignServiceProvider } from '../../../ranking/services/campaign-service/campaign-service';
import { ClientServiceProvider } from '../../../clients/services/client-service/client-service';
import { DisplayServiceProvider } from '../display-service/display-service';
import { EventsServiceProvider } from '../../../calendar/services/events-service/events-service';
import { FilterServiceProvider } from '../filter-service/FilterServiceProvider';
import { GroupServiceProvider } from '../group-service/group-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KnowledgeServiceProvider } from '../../../knowledge/services/knowledge-service/knowledge-service';
import { KpiServiceProvider } from '../../../ranking/services/kpi-service/kpi-service';
import { LayoutServiceProvider } from '../layout-service/layout-service';
import { NewsService } from '../../../news/services/news-service/news-service';
import { NonWorkingDaysConfigServiceProvider } from '../non-working-days-config-service/non-working-days-config-service';
import { PlayerServiceProvider } from '../player-service/player-service';
import { PrizesServiceProvider } from '../../../prizes/services/prizes-service/prizes-service';
import { ProjectService } from '../../../projects/services/project.service';
import { PushServiceProvider } from '../push-service/push-service';
import { QuizzesServiceProvider } from '../../../quizzes/services/quizzes-service/quizzes-service';
import { RankingServiceProvider } from '../../../ranking/services/ranking-service/ranking-service';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { TaskService } from '../../../tasks/services/task.service';
import { TasksServiceProvider } from '../../../ranking/services/tasks-service/tasks-service';
import { TextServiceProvider } from '../text-service/text-service';
import { UserGroupsServiceProvider } from '../user-groups-service/user-groups-service';
import { UsersServiceProvider } from '../users-service/users-service';
import { ENVIRONMENT } from '../../../../../environments/environment';
import { reject } from 'lodash';

@Injectable()
export class DataUpdateServiceProvider {
  private synchronizeTimeDiff = 1000 * 60 * 30;

  constructor(
    private app: App,
    private achievementService: AchievementsServiceProvider,
    private campaignService: CampaignServiceProvider,
    private clientService: ClientServiceProvider,
    private displayService: DisplayServiceProvider,
    private eventsService: EventsServiceProvider,
    private filterService: FilterServiceProvider,
    private groupService: GroupServiceProvider,
    private knowledgeService: KnowledgeServiceProvider,
    private kpiService: KpiServiceProvider,
    private layoutService: LayoutServiceProvider,
    private newsService: NewsService,
    private nonWorkingDaysConfigService: NonWorkingDaysConfigServiceProvider,
    private playerService: PlayerServiceProvider,
    private prizesService: PrizesServiceProvider,
    private projectService: ProjectService,
    private pushService: PushServiceProvider,
    private rankingService: RankingServiceProvider,
    private representativeTasksService: TaskService,
    private storageService: StorageServiceProvider,
    private tasksService: TasksServiceProvider,
    private userGroupsService: UserGroupsServiceProvider,
    private repTaskService: TaskService,
    private usersService: UsersServiceProvider,
    private quizService: QuizzesServiceProvider,
    public http: HttpClient,
    public textService: TextServiceProvider,
  ) {}

  public loadInternalData() {
    return Promise.all([this.displayService.load(), this.layoutService.load(), this.textService.load()]);
  }

  public load() {
    return this.newsService.load().toPromise()
      .then(() => Promise.all(this.getLoadPromises()))
      .then(() => this.filterService.load())
      .then(() => this.clientService.load())
      .then(() => this.eventsService.load())
      .then(() => {
        this.userGroupsService.load();
        this.campaignService.load();
        this.pushService.registerPushNotifications();
        window.localStorage.setItem('lastUpdate', new Date().toJSON());
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  }

  private getLoadPromises() {
    const promises: Promise<any>[] = [];
    ENVIRONMENT.loadDataFrom.forEach((service) => promises.push(this[service].load()));
    return promises;
  }

  public synchronize() {
    if (window.localStorage.getItem('lastUpdate')) {
      let currentTime = Number(new Date());
      let lastUpdate = Number(new Date(window.localStorage.getItem('lastUpdate')));

      if (currentTime - lastUpdate < this.synchronizeTimeDiff) return;
    }

    this.app.getRootNav().setRoot('LoadingPage', {}, { animate: true });
  }

  public flushData() {
    this.campaignService.resetPlayerCampaigns();
    this.storageService.set('accessToken', null);
    this.storageService.set('refreshToken', null);
    this.rankingService.setFilters(null);
    this.rankingService.setGroupFilters(null);
    this.rankingService.setHistoryFilters(null);
    this.pushService.unregisterPushNotifications().catch((err) => console.error(err));
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/data-update-service/data-update-service.ts